import React from 'react'
import PaymentDetails from '../components/Payments/PaymentDetails'
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

const publisable_key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY

const stripePromise = loadStripe(publisable_key);
function Payments() {
  return (
    <div className='bg-greenOnDarkMode text-white px-3 py-5 sm:p-5 mt-[100px]'>
    <Elements stripe={stripePromise}>
    <PaymentDetails />
    </Elements>

    </div>
  )
}

export default Payments
